// extracted by mini-css-extract-plugin
export default {"button":"styles_button__ne8eZ","reactIcons":"styles_reactIcons__tWJ4i"};